import { RequestKind, boolean } from '@sb/library/base';
import { DisplayItemCollection, NotificationDisplayItem, NotificationSearchOptions, NotificationSeenUpdateItem } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace NotificationsRoutes {
    export const Get = ApiRoute.Define({
        URL: (notificationID: string) => `notifications/${notificationID}`,
        Kind: RequestKind.Get,
        ResultType: NotificationDisplayItem,
    });

    export const Search = ApiRoute.Define({
        URL: 'search/notifications/',
        Kind: RequestKind.Post,
        BodyType: NotificationSearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<NotificationDisplayItem>
    });

    export const Delete = ApiRoute.Define({
        URL: (id: string) => `notifications/${id}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Update = ApiRoute.Define({
        URL: (id: string) => `notifications/${id}/seen`,
        Kind: RequestKind.Patch,
        BodyType: NotificationSeenUpdateItem,
        ResultType: boolean,
    });

    export const MarkAllAsRead = ApiRoute.Define({
        URL: 'notifications/markallseen',
        Kind: RequestKind.Post,
        ResultType: boolean
    });
}
